export default __webpack_public_path__ + "static/media/Himanshu_Resume.6a98df91.pdf";